import { Close } from "@mui/icons-material";
import {
  Alert,
  AlertTitle,
  Chip,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import React, { useContext, useState } from "react";
import { CustomButton } from "src/Components/Common/Button/CustomButton";
import LoadingIcon from "src/Components/Common/LoadingIcon";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";
import { userContext } from "src/Components/Contexts/userContext";
import { columnHeaderDescription, groupLabels } from "src/Utils/Recon/ColumnHeaderConfig/Constants";
import {
  BUSINESS_PARTNER_LEDGER,
  columnHeaderNameLabel,
  compulsoryColumnHeader,
  Customized,
  OWN_LEDGER,
  transFormColumnHeader,
} from "src/Utils/Recon/Recon360/Constants";
import { uiLoggerName } from "../../../Utils/Recon/UiLogger/Constants";
import { Recon360Context } from "../Recon360";
import { ENTITY_TYPE_ALLOWED_ACTOR_IDS } from "../Transformer/ColumnHeaderConfig";

export default function ColumnHeaderModal() {
  const { actor } = useContext(userContext);
  const {
    openColumnHeaderDialog,
    setOpenColumnHeaderDialog,
    fetchDataFromERP,
    sheetNameForUnidentified,
    ignoreDoctypesList,
    configUserType,
    columnHeaderArr,
    setColumnHeaderArr,
    isOpenSelectTemplateUploadConfirmRefOwn,
    isOpenSelectTemplateUploadConfirmRefBp,
    highlightedHeader,
    setHighlightedHeader,
    listColumnHeaderEntries,
    headerNameBp,
    headerName,
    saveRuleApi,
    sanitizeColBusiness,
    businessPartnerIntegrationWithERP,
    compareLedgersCheckEndDate,
    uiLogger,
    documentTypesArr,
    setOpenDocumentTypeDialog,
    reUploadLedger,
    saveRuleApiOwn,
    sanitizeColOwn,
    fileNameForUnidentified,
    cancelUploadRequest,
    loadingConfigOwn,
    loadingConfigBP,
  } = useContext(Recon360Context);
  const [openColumnHeaderFoundMsg, setOpenColumnHeaderFoundMsg] = useState(true);
  const [openColumnHeaderDialogLeftToMap, setOpenColumnHeaderDialogLeftToMap] = useState(false);

  const highlightOnClick = (item) => {
    setHighlightedHeader({
      columnHeaderName: item?.columnHeaderName,
      columnHeaderConfigValue: item?.columnHeaderConfigValue,
    });
  };

  const changeColumnHeaderConfig = (item: any, value: any) => {
    setHighlightedHeader({ columnHeaderName: item, columnHeaderConfigValue: value });

    // Create a new array with the updated values
    const updatedColumnHeaderArr = columnHeaderArr.map((object) => {
      if (object.columnHeaderName === item) {
        // Create a new object with the updated values
        return { ...object, errorFlag: false, columnHeaderConfigValue: value };
      }
      return object;
    });

    // Set the state with the updated array
    setColumnHeaderArr(updatedColumnHeaderArr);

    if (configUserType === BUSINESS_PARTNER_LEDGER) {
      Object.keys(headerNameBp).forEach((k: any) => {
        if (k === item) {
          // const tempColumnHeaderConfigValue =
          columnHeaderArr.map((object: any, index: any) => {
            // return { ...object, columnHeaderConfigValue: value };
            if (object.columnHeaderName === item) {
              columnHeaderArr[index].columnHeaderConfigValue = value;
            }
            return columnHeaderArr;
          });
          // setColumnHeaderArr(tempColumnHeaderConfigValue);
          setColumnHeaderArr(columnHeaderArr);
        }
      });
    } else if (configUserType === OWN_LEDGER) {
      Object.keys(headerName).forEach((k: any) => {
        if (k === item) {
          // const tempColumnHeaderConfigValue =
          columnHeaderArr.map((object: any, index: any) => {
            if (object.columnHeaderName === item) {
              columnHeaderArr[index].columnHeaderConfigValue = value;
            }
            // return { ...object, columnHeaderConfigValue: value };
            return columnHeaderArr;
          });
          // setColumnHeaderArr(tempColumnHeaderConfigValue);
          setColumnHeaderArr(columnHeaderArr);
        }
      });
    }
  };
  const saveColumnHeaderConfig = async (checkHasEmptyConfigValue) => {
    // Filter out items with "columnHeaderConfigValue" equal to "Never Ask Again"
    const updatedColumnHeaderArr = columnHeaderArr.filter((item) => item.columnHeaderConfigValue !== "Never ask again");
    if (checkHasEmptyConfigValue) {
      // Check if there are any items with an empty columnHeaderConfigValue
      const hasEmptyConfigValue = updatedColumnHeaderArr.some((item) => item.columnHeaderConfigValue === "");

      if (hasEmptyConfigValue) {
        setOpenColumnHeaderDialogLeftToMap(true);
        return;
      }
    }

    if (configUserType === BUSINESS_PARTNER_LEDGER) {
      Object.keys(headerNameBp).map((k: any) => {
        updatedColumnHeaderArr.map((item: any) => {
          if (k === item.columnHeaderName) {
            const temp = headerNameBp[k].length;
            let tempFlag = true;
            if (item?.columnHeaderConfigValue !== undefined && item?.columnHeaderConfigValue !== "") {
              if (headerNameBp[k][0] === "") {
                headerNameBp[k][0] = item?.columnHeaderConfigValue;
                tempFlag = false;
              } else {
                if (!item.alreadyMappedColumnHeaders) {
                  headerNameBp[k].push(item?.columnHeaderConfigValue);
                }
              }
            }
            if (headerNameBp[k][0] === "") {
              item.errorFlag = true;
            } else if (temp === headerNameBp[k].length && tempFlag) {
              item.errorFlag = true;
            }
          }
          return updatedColumnHeaderArr;
        });
        return updatedColumnHeaderArr;
      });

      // do not ask to reupload after unassigned col headers saved
      await saveRuleApi(headerNameBp, Customized, sanitizeColBusiness, true, true, false);
      if (businessPartnerIntegrationWithERP) {
        compareLedgersCheckEndDate();
      }
      setOpenColumnHeaderDialog(false);
      if (documentTypesArr.length > 0) {
        setOpenDocumentTypeDialog(true);
        uiLogger(uiLoggerName.ui_BpAutoConfigOpen);
      } else {
        if (!fetchDataFromERP) {
          // excelFileUploadOnChange(excelFileUploadOnChangeEvent, excelFileUploadOnChangeFileName);
          reUploadLedger("false");
        }
      }
      // }
      uiLogger(uiLoggerName.ui_BpAutoConfigClose);
    } else if (configUserType === OWN_LEDGER) {
      Object.keys(headerName).map((k) => {
        updatedColumnHeaderArr.map((item: any) => {
          if (k === item.columnHeaderName) {
            const temp = headerName[k].length;
            let tempFlag = true;
            if (item?.columnHeaderConfigValue !== undefined && item?.columnHeaderConfigValue !== "") {
              if (headerName[k][0] === "") {
                headerName[k][0] = item?.columnHeaderConfigValue;
                tempFlag = false;
              } else {
                if (!item.alreadyMappedColumnHeaders) {
                  headerName[k].push(item?.columnHeaderConfigValue);
                }
              }
            }

            if (headerName[k][0] === "") {
              item.errorFlag = true;
            } else if (temp === headerName[k].length && tempFlag) {
              item.errorFlag = true;
            }
          }
          return updatedColumnHeaderArr;
        });
        return updatedColumnHeaderArr;
      });

      // do not ask to reupload after unassigned col headers saved
      await saveRuleApiOwn(headerName, Customized, sanitizeColOwn, true, true, false);
      if (actor.integration) {
        compareLedgersCheckEndDate();
      }
      setOpenColumnHeaderDialog(false);
      if (documentTypesArr.length > 0) {
        setOpenDocumentTypeDialog(true);
        uiLogger(uiLoggerName.ui_OwnAutoConfigOpen);
      } else {
        if (!fetchDataFromERP) {
          // excelFileUploadOnChange(excelFileUploadOnChangeEvent, excelFileUploadOnChangeFileName);
          reUploadLedger("false");
        }
      }
      uiLogger(uiLoggerName.ui_OwnAutoConfigClose);
    }
  };

  return (
    <>
      <Dialog open={openColumnHeaderDialog} maxWidth={DIALOG_MAX_WIDTHS.MD} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="space_between w_100_per vertical_center_align">
            <div style={{ maxWidth: "60%" }}>
              <div className="heading-m">Create Configuration</div>
              <p className="d_flex mt_6">
                {!fetchDataFromERP && (
                  <span className="file_name_border">
                    <span className="fw_700">File: </span>
                    {fileNameForUnidentified}
                  </span>
                )}

                {sheetNameForUnidentified && (
                  <span className="file_name_border ml_5">
                    <span className="fw_700">Sheet: </span>
                    {sheetNameForUnidentified}
                  </span>
                )}
              </p>
            </div>
            <div className="step_text">Step 1 of 2 - Map Column Headers</div>
            <div className="vertical_center_align">
              <IconButton
                onClick={() => {
                  // clear ignore doc type list on close click
                  ignoreDoctypesList.current = [];

                  if (fetchDataFromERP) {
                    setOpenColumnHeaderDialog(false);
                  } else {
                    setOpenColumnHeaderDialog(false);
                  }
                  isOpenSelectTemplateUploadConfirmRefOwn.current = false;
                  isOpenSelectTemplateUploadConfirmRefBp.current = false;
                  if (!fetchDataFromERP) {
                    cancelUploadRequest();
                  }
                }}
              >
                <Close />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers style={{ padding: "16px 4px 16px 16px" }}>
          <Grid container={true} spacing={2}>
            <Grid xs={9.5} className=" p_16 column_header_scrollbar">
              <Grid>
                <div className="mb_8">
                  <Typography
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                    }}
                    className="vertical_center_align mb_8"
                  >
                    <span>*&nbsp;</span> Compulsory columns which need to be mapped to proceed for reconciliation
                  </Typography>
                </div>
                <Collapse in={openColumnHeaderFoundMsg} className={openColumnHeaderFoundMsg ? "pb_16" : ""}>
                  <Alert
                    severity="info"
                    onClose={() => {
                      setOpenColumnHeaderFoundMsg(false);
                    }}
                    className="alert_text_unassigned"
                  >
                    <AlertTitle>Unassigned Column Headers Found</AlertTitle>
                    We have already Pre-filled the Unassigned Column headers for you. Edit/modify/verify them as per
                    your requirement
                  </Alert>
                </Collapse>
              </Grid>
              {columnHeaderArr &&
                columnHeaderArr
                  ?.filter((item: any) => {
                    // Show entityType ONLY for specific actor IDs
                    if (item.columnHeaderName === columnHeaderNameLabel.entityType) {
                      return ENTITY_TYPE_ALLOWED_ACTOR_IDS.includes(actor.id);
                    }
                    return true;
                  })
                  .map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {(item.columnHeaderName === columnHeaderNameLabel.documentDate ||
                        item.columnHeaderName === columnHeaderNameLabel.debitAmount ||
                        item.columnHeaderName === columnHeaderNameLabel.referenceNumber ||
                        item.columnHeaderName === columnHeaderNameLabel.miscellaneous) && (
                        <Grid className="theme_bg_col_header">
                          <h3 className="fw_900">{groupLabels[index]}</h3>
                        </Grid>
                      )}
                      <Grid
                        className={`${
                          item.unassignedColumnHeadersFound ? "config_box_card_column_found" : "config_box_card"
                        } cursor_pointer`}
                        style={{
                          border:
                            highlightedHeader?.columnHeaderName === item.columnHeaderName
                              ? "2px solid #531c4c"
                              : "1px solid rgba(0, 0, 0, 0.08)",
                        }}
                        onClick={() => {
                          highlightOnClick(item);
                        }}
                      >
                        <Grid className="space_between">
                          <h3 className="fw_900 center_align_ver_horiz">
                            {transFormColumnHeader(item.columnHeaderName)}
                            {compulsoryColumnHeader.includes(item.columnHeaderName) && " *"}
                            {item.unassignedColumnHeadersFound && (
                              <span className="ml_10">
                                <Chip
                                  label="Check if mapped column is correct"
                                  color="primary"
                                  size="small"
                                  style={{ fontSize: "13px !important" }}
                                />
                              </span>
                            )}
                          </h3>
                        </Grid>
                        <Grid className="desc_name">{columnHeaderDescription[item.columnHeaderName]}</Grid>

                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <FormControl
                              className="update-custom-border-radius"
                              fullWidth={true}
                              disabled={item.alreadyMappedColumnHeaders}
                              // error={item?.errorFlag}
                            >
                              <Select
                                size="small"
                                name="columnHeader"
                                variant="outlined"
                                fullWidth={true}
                                // multiple={item.columnHeaderName === columnHeaderNameLabel.miscellaneous ? true : false}
                                defaultValue={
                                  item?.columnHeaderConfigValue !== "" ? [item?.columnHeaderConfigValue] : []
                                }
                                value={item?.columnHeaderConfigValue !== "" ? [item?.columnHeaderConfigValue] : []}
                                // value={item?.columnHeaderConfigValue?.includes(',') ? item?.columnHeaderConfigValue.split(',') : [item?.columnHeaderConfigValue]}
                                displayEmpty={true}
                                onChange={(e) => {
                                  changeColumnHeaderConfig(item.columnHeaderName, e.target.value);
                                }}
                                renderValue={(selected) => {
                                  if (selected.length === 0) {
                                    return <span>Select Column</span>; // Placeholder text when nothing is selected
                                  }
                                  return (
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                      {selected.map((option) => (
                                        <Chip key={option} label={option} />
                                      ))}
                                    </div>
                                  );
                                }}
                              >
                                {/* Conditionally render Clear option */}
                                {!compulsoryColumnHeader.includes(item.columnHeaderName) && (
                                  <MenuItem
                                    value=""
                                    onClick={() => {
                                      changeColumnHeaderConfig(item.columnHeaderName, []); // Reset the selection
                                    }}
                                  >
                                    Remove Selection
                                  </MenuItem>
                                )}
                                <MenuItem disabled={true} value="">
                                  Select Column
                                </MenuItem>
                                {item.columnHeaders.map((val: any, ind: any) => (
                                  <MenuItem key={ind} value={val}>
                                    {val}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  ))}
            </Grid>
            <Grid xs={2.5} className="column_header_entries_scrollbar ">
              <div className="m_8 text_center col_header_entries">
                <div className="col_header_entries_heading">
                  <p className="mb_15">
                    {highlightedHeader?.columnHeaderConfigValue ? (
                      <>
                        <span className="fw_700">{highlightedHeader.columnHeaderConfigValue}</span> Column has following
                        entries in the ledger
                      </>
                    ) : (
                      <>
                        <span className="fw_700">No Preview:</span> Please select a column to view entries
                      </>
                    )}
                  </p>
                </div>
                <div>
                  {listColumnHeaderEntries?.map(
                    (entry) =>
                      entry.header === highlightedHeader?.columnHeaderConfigValue &&
                      entry.data?.map((entryItem, entryIndex) => (
                        <p key={entryIndex} className="col_header_entries_list">
                          {(highlightedHeader?.columnHeaderName === "debitAmount" ||
                            highlightedHeader?.columnHeaderName === "creditAmount") &&
                          typeof entryItem === "number"
                            ? entryItem.toLocaleString("en-IN")
                            : entryItem}
                        </p>
                      ))
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <div className="w_100_per right_align">
            <CustomButton
              size="medium"
              colorToken="violet"
              variant="contained"
              onClick={() => {
                saveColumnHeaderConfig(true);
              }}
            >
              Save and Proceed
            </CustomButton>
          </div>
        </DialogActions>
      </Dialog>
      <Dialog open={openColumnHeaderDialogLeftToMap} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m">There are still Column header left to be mapped</div>
          <div className="vertical_center_align">
            <IconButton
              onClick={() => {
                setOpenColumnHeaderDialogLeftToMap(false);
              }}
            >
              <Close />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <Grid className="mb_20">
            <Alert severity="info" style={{ fontSize: "14px" }}>
              <span style={{ fontWeight: 600 }}>To get the best Reconciliation output,</span> it is advised that you
              fill all the applicable Column headers
            </Alert>
          </Grid>
          <Grid>
            {columnHeaderArr
              .filter((item) => item.columnHeaderConfigValue === "")
              .map((item, index) => (
                <Grid
                  key={index}
                  className="config_box_card cursor_pointer"
                  style={{
                    border: "1px solid rgba(0, 0, 0, 0.08)",
                  }}
                >
                  <Grid className="space_between">
                    <h3 className="fw_900 center_align_ver_horiz">{transFormColumnHeader(item.columnHeaderName)}</h3>
                  </Grid>
                  <Grid className="desc_name">{columnHeaderDescription[item.columnHeaderName]}</Grid>
                </Grid>
              ))}
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <div className="w_100_per right_align">
            <CustomButton
              startIcon={<LoadingIcon loading={loadingConfigBP || loadingConfigOwn} />}
              size="medium"
              colorToken="violet"
              variant="text"
              onClick={() => {
                saveColumnHeaderConfig(false);
              }}
              disabled={loadingConfigBP || loadingConfigOwn}
            >
              Save and Proceed
            </CustomButton>
            <CustomButton
              size="medium"
              colorToken="violet"
              variant="contained"
              disabled={loadingConfigBP || loadingConfigOwn}
              onClick={() => {
                setOpenColumnHeaderDialogLeftToMap(false);
              }}
            >
              Map Columns
            </CustomButton>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
